export const PARAMETER_TO_STOCK_SOLUTION = {
    alkalinity: 'alk_bicarb',
    calcium: 'calcium',
    magnesium: 'magnesium',
    // The stock solutions catalog does NOT have a "nitrate" or "phosphate"
    // top-level key — only nitrogen-source and phosphate-remover recipes
    // that aren't a clean 1:1 match for "raise nitrate" / "raise phosphate".
    nitrate: null,
    phosphate: null,
    ammonia: null,
    nitrite: null,
    ph: null,
    salinity: null,
    iodine: null,
    potassium: null,
    other: null,
};
/**
 * Return the Stock Solutions catalog key for a given test parameter,
 * or `null` when no direct mapping exists.
 */
export function stockSolutionKeyForParameter(parameterKey) {
    return PARAMETER_TO_STOCK_SOLUTION[parameterKey];
}
//# sourceMappingURL=stock-solution-mapping.js.map